var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
export var replacement = [{
  reg: /\*/g,
  dest: '×'
}, {
  reg: /\//g,
  dest: '÷'
}];
var ResultPanel = (_temp = _class = function (_React$Component) {
  _inherits(ResultPanel, _React$Component);

  function ResultPanel() {
    _classCallCheck(this, ResultPanel);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ResultPanel.prototype.render = function render() {
    var _props = this.props,
        last = _props.last,
        cur = _props.cur;
    var finalCur = cur,
        finalLast = last;
    replacement.forEach(function (item) {
      finalCur = finalCur.replace(item.reg, item.dest);
      finalLast = finalLast.replace(item.reg, item.dest);
    });
    return React.createElement('div', {
      className: 'result-panel'
    }, React.createElement('div', {
      className: 'last-row'
    }, finalLast), React.createElement('input', {
      className: 'cur-row',
      value: finalCur,
      readOnly: true
    }));
  };

  return ResultPanel;
}(React.Component), _class.defaultProps = {
  curr: '0',
  last: ''
}, _temp);
export { ResultPanel as default };
ResultPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  last: PropTypes.string,
  cur: PropTypes.string,
  onInputChange: PropTypes.func
} : {};